export enum TreatmentPlanStepType {
  UPPER = "UPPER",
  LOWER = "LOWER",
}
